import { RotateCcw, TrendingUp } from "lucide-react";
import { fmtTL } from "../../lib/format";
import AmountInput from "../AmountInput";
import { Field, ReadonlyBox, inputCls } from "./fields";

const TOGGLE_BASE = "inline-flex items-center gap-2 px-3 py-2 rounded-md text-xs font-semibold border transition-colors";
const TELAFI_CLS = { on: "bg-amber-500 text-white border-amber-500", off: "bg-white text-slate-600 border-slate-300 hover:border-amber-400" };
const FF_CLS = { on: "bg-sky-600 text-white border-sky-600", off: "bg-white text-slate-600 border-slate-300 hover:border-sky-400" };

// Telafi Temizliği / Fiyat Farkı anahtarları + fiyat farkı paneli
export default function EntryModeToggles({ telafi, setTelafi, fiyatFarki, setFiyatFarki, ffPrice, setFfPrice, editMode, service, ffNewTotal, ffDiff }) {
  const toggleTelafi = () => { const next = !telafi; setTelafi(next); if (next) { setFiyatFarki(false); setFfPrice(""); } };
  const toggleFf = () => { const next = !fiyatFarki; setFiyatFarki(next); if (next) setTelafi(false); else setFfPrice(""); };
  return (
    <>
      <div className="flex items-center justify-between gap-3 flex-wrap pt-2 border-t border-slate-100">
        <div className="flex items-center gap-3 flex-wrap">
          <button type="button" onClick={toggleTelafi} data-testid="entry-telafi-toggle" className={`${TOGGLE_BASE} ${telafi ? TELAFI_CLS.on : TELAFI_CLS.off}`}>
            <RotateCcw className="w-3.5 h-3.5" /> Telafi Temizliği: {telafi ? "Açık" : "Kapalı"}
          </button>
          {!editMode && <button type="button" onClick={toggleFf} data-testid="entry-fiyatfarki-toggle" className={`${TOGGLE_BASE} ${fiyatFarki ? FF_CLS.on : FF_CLS.off}`}>
            <TrendingUp className="w-3.5 h-3.5" /> Fiyat Farkı: {fiyatFarki ? "Açık" : "Kapalı"}
          </button>}
        </div>
        {telafi && <span className="text-[11px] text-amber-700" data-testid="telafi-hint">Bu kayıt bilgi amaçlıdır — müşteri gelirine ve taşeron giderine dahil edilmez, hakedişlerde ₺0,00 ile görünür.</span>}
      </div>

      {fiyatFarki && (
        <div className="rounded-lg border-2 border-sky-300 bg-sky-50/50 p-4 space-y-3" data-testid="fiyat-farki-panel">
          <div className="text-sm font-bold text-sky-900" data-testid="fiyat-farki-title">{service ? `${service.name} Fiyat Farkı` : "Fiyat Farkı"}</div>
          <div className="text-[11px] text-sky-800">Fark müşteri hakedişine yansımaz; taşeron hakedişine ayrı satır olarak eklenir. Yalnızca artış yönünde fark girilebilir.</div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Field label="Yeni Birim Fiyatı (Taşeron)">
              <AmountInput testid="entry-ff-price" value={ffPrice} onChange={setFfPrice} placeholder="örn. 1.600,00" className={inputCls} />
            </Field>
            <ReadonlyBox label="Yeni Tutar (Miktar × Yeni Birim Fiyatı)" value={fmtTL(ffNewTotal)} testid="entry-ff-total" />
            <ReadonlyBox label="Fark Tutarı (Yeni Tutar − Taşeron Tutarı)" value={fmtTL(ffDiff > 0 ? ffDiff : 0)} testid="entry-ff-diff" />
          </div>
        </div>
      )}
    </>
  );
}
